<template>
  <DrawingForm />
</template>
  
<script>
  import DrawingForm from '@/components/seni/DrawingForm.vue';
  export default {
    name: "DrawingCreatePage",
    components: {
      DrawingForm,
    },
  };
</script>
  